import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, type Brand } from "../lib/api.ts";
import { useBrands } from "../lib/brand.tsx";
import { Icon } from "../lib/icons.tsx";

const KIND_LABEL: Record<string, string> = { sooksabay: "Sooksabay", mcalive: "McAlive", client: "ลูกค้า" };

export default function Brands() {
  const { brands, reload, setActiveBrandId } = useBrands();
  const nav = useNavigate();
  const [creating, setCreating] = useState(false);
  const [name, setName] = useState("");
  const [kind, setKind] = useState("client");
  const [busy, setBusy] = useState(false);

  async function create(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    try {
      const r = await api.post<{ brand: Brand }>("/brands", { name: name.trim(), kind });
      await reload();
      setActiveBrandId(r.brand.id);
      setCreating(false);
      setName("");
      nav(`/brands/${r.brand.id}`);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="page">
      <div className="page__head mh-spread">
        <div>
          <div className="page__title">แบรนด์ & ลูกค้า</div>
          <div className="page__subtitle">แต่ละแบรนด์เก็บ Brand Brain แยกกัน — ข้อมูลไม่ปะปน</div>
        </div>
        <button className="mh-btn mh-btn--primary" onClick={() => setCreating((v) => !v)}>
          <Icon name="Plus" size={18} /> สร้างแบรนด์
        </button>
      </div>

      {creating && (
        <form className="mh-card card-pad" style={{ marginBottom: 20 }} onSubmit={create}>
          <div className="form-grid">
            <div className="mh-field" style={{ margin: 0 }}>
              <label className="mh-label">ชื่อแบรนด์</label>
              <input className="mh-input" autoFocus value={name} onChange={(e) => setName(e.target.value)} placeholder="เช่น Sooksabay Online, McAlive, ลูกค้า A" />
            </div>
            <div className="mh-field" style={{ margin: 0 }}>
              <label className="mh-label">ประเภท</label>
              <select className="mh-select" value={kind} onChange={(e) => setKind(e.target.value)}>
                <option value="sooksabay">Sooksabay Online</option>
                <option value="mcalive">McAlive</option>
                <option value="client">ลูกค้า (Client)</option>
              </select>
            </div>
          </div>
          <div style={{ marginTop: 14, display: "flex", gap: 10 }}>
            <button className="mh-btn mh-btn--primary" disabled={busy}>{busy ? <span className="spinner" /> : "สร้าง & ตั้งค่า Brand Brain"}</button>
            <button type="button" className="mh-btn mh-btn--ghost" onClick={() => setCreating(false)}>ยกเลิก</button>
          </div>
        </form>
      )}

      {brands.length === 0 && !creating ? (
        <div className="empty">
          <div className="empty__icon"><Icon name="Building2" size={30} /></div>
          <h3>ยังไม่มีแบรนด์</h3>
          <p className="mh-sec">สร้างแบรนด์แรกเพื่อให้ AI ทำงานตรงบริบท</p>
          <button className="mh-btn mh-btn--primary" onClick={() => setCreating(true)}><Icon name="Plus" size={18} /> สร้างแบรนด์แรก</button>
        </div>
      ) : (
        <div className="cards">
          {brands.map((b) => (
            <div className="mh-card card-pad" key={b.id} style={{ cursor: "pointer" }} onClick={() => { setActiveBrandId(b.id); nav(`/brands/${b.id}`); }}>
              <div className="mh-spread">
                <div className="qa__icon" style={{ background: b.color || "var(--blue-050)" }}><Icon name="Building2" /></div>
                <span className="mh-pill mh-pill--neutral">{KIND_LABEL[b.kind] ?? b.kind}</span>
              </div>
              <div style={{ fontWeight: 700, fontSize: 17, marginTop: 12 }}>{b.name}</div>
              <div className="mh-row" style={{ marginTop: 10, color: "var(--blue-600)", fontWeight: 600, fontSize: 14, gap: 4 }}>
                เปิด Brand Brain <Icon name="ChevronRight" size={16} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
